import React, { useEffect, useState } from 'react'
import Icon from '@ant-design/icons'
import { Badge } from 'antd'
import MessagerIcon from './message-icon.component'
import { useHookstate } from '@hookstate/core'
import { NotificationsGlobalState } from '../../../../refactory/kernel/infrastructure/notifications/notifications-global-state'

const ChatNotification = ({ job }) => {
  const { messages } = useHookstate(NotificationsGlobalState)
  const [hasChat, setHasChat] = useState(false)

  useEffect(() => {
    setHasChat(job.lastFlag?.category?.name.toUpperCase().includes('CHAT'))
  }, [job])

  const showCounter = () => {
    return (
      <div>
        <Badge dot={true} offset={[1, 1]}>
          <Icon component={MessagerIcon} />
        </Badge>
      </div>
    )
  }

  return (
    <div
      className='chat-notification'
      style={{
        display: messages.get().filter((message) => message.jobId === job.uuid).length > 0 || hasChat ? 'block' : 'none'
      }}
    >
      {showCounter()}
    </div>
  )
}

export default ChatNotification
